import { useEffect } from "react";
import Cal, { getCalApi } from "@calcom/embed-react";
import ModalBasicLayout from "./ModalBasicLayout";
import Box from "@mui/material/Box";
import { useTranslationApp } from "../../lib/i18next";
import i18next from "i18next";
import { getLanguageFormatted } from "../../utils/string";
import {
  MODAL_AD_HOC_SUPPORT_ARIA_LABEL,
  MODAL_AD_HOC_SUPPORT_DESCRIPTION,
  MODAL_AD_HOC_SUPPORT_TITLE,
} from "../../i18n/keysTranslations";

const CAL_AD_HOC_SUPPORT_LINK_EN =
  "team/customer-success-adle/ad-hoc-support-session-clients";
const CAL_AD_HOC_SUPPORT_LINK_ES = "team/customer-success-adle/soporte-adle";
const CAL_AD_HOC_SUPPORT_NAMESPACE = "adHocSupport";

const ModalAdHocSupport = ({
  modalOpen = false,
  onCloseModal = () => {},
}) => {
  const { t } = useTranslationApp();
  const language = getLanguageFormatted(i18next.language);
  const calLink =
    language === "es"
      ? CAL_AD_HOC_SUPPORT_LINK_ES
      : CAL_AD_HOC_SUPPORT_LINK_EN;

  useEffect(() => {
    if (!modalOpen) return;

    let isMounted = true;

    const onInitCalUi = async () => {
      const cal = await getCalApi({ namespace: CAL_AD_HOC_SUPPORT_NAMESPACE });
      if (!isMounted) return;

      cal("ui", {
        theme: "light",
        hideEventTypeDetails: true,
        styles: {
          body: { background: "transparent" },
        },
        cssVarsPerTheme: {
          light: {
            "cal-bg": "#ffffff",
          },
        },
      });
    };

    onInitCalUi();

    return () => {
      isMounted = false;
    };
  }, [modalOpen]);

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth
      maxWidth="md"
      scroll="paper"
      showCloseButton
      ariaLabel={t(MODAL_AD_HOC_SUPPORT_ARIA_LABEL)}
      title={t(MODAL_AD_HOC_SUPPORT_TITLE)}
      description={t(MODAL_AD_HOC_SUPPORT_DESCRIPTION)}
      sxContent={{
        overflow: "hidden",
        pb: 3,
      }}
    >
      <Box
        sx={{
          overflow: "hidden",
          position: "relative",
          width: "100%",
          height: 600,
        }}
      >
        {modalOpen ? (
          <Cal
            key={calLink}
            namespace={CAL_AD_HOC_SUPPORT_NAMESPACE}
            calLink={calLink}
            style={{ width: "100%", height: "100%", overflow: "scroll" }}
            config={{
              layout: "month_view",
              theme: "light",
            }}
          />
        ) : null}
      </Box>
    </ModalBasicLayout>
  );
};

export default ModalAdHocSupport;
